import React, { useEffect, useRef, useState } from "react";
import { Button, Input, Modal, Select, Space, Table } from "antd";
import Styles from "./Styles";
import SearchArea from "../../components/moleculas/SearchArea";
import { apiGet, apiGetDeviceStat, apiGetDeviceStatCam, apiGetServiceCode, apiGetSitesComp } from "../../api/api";
import Moment from "react-moment";
import {
  getGlobalSessionParam,
  getSessionParam,
  isEmpty,
  setGlobalSessionParam,
  setSessionParam,
} from "../../utils/comm";
import PopDeviceStatus from "./PopDeviceStatus";
import SectionTitleArea from "../../components/moleculas/SectionTitleArea";

const { Option } = Select;
const { Search } = Input;
const { Column, ColumnGroup } = Table;

function ManageDevice() {
  const [defaultValue] = useState({
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
    svcCd: !isEmpty(getGlobalSessionParam("svcCd")) ? getGlobalSessionParam("svcCd") : null,
  });

  const StatusOptions = {
    SITE: "SITE",
    SERVICE: "SERVICE",
    SEARCH: "SEARCH",
  };
  const initStatus = useRef(
    new Map([
      [StatusOptions.SITE, false],
      [StatusOptions.SERVICE, false],
      [StatusOptions.SEARCH, false],
    ])
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCheckOption, setSelectedCheckOption] = useState(null);
  const [formData, setFormData] = useState({ siteId: null, searchKeyword: "" });
  const [deviceData, setDeviceData] = useState([]);
  const [mediaData, setMediaData] = useState([{ serialNo: null, znNm: null, updateDt: null, fileNm: null }]);
  const [sitesData, setSitesData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [appStat, setAppStat] = useState();
  let siteId = null;

  // 입력폼
  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData({ ...formData, [id]: value });
  };

  // 사업장 드롭박스
  const apiGetSitesCompCall = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetSitesComp(model);

      if (response.data.code === 0) {
        setSitesData([...response.data.data]);
      } else {
        setSitesData([]);
      }
    } catch (e) {
      setSitesData([]);
    }
  };

  // 입력폼
  function changeSite(value) {
    siteId = value;
    setFormData({ ...formData, ["siteId"]: value });
    apiGetServiceCodeCall(null).then();
    apiGetDeviceStatCall(formData.searchKeyword, false).then();
  }

  // 서비스 드롭박스
  const apiGetServiceCodeCall = async (sId) => {
    const model = {
      siteId: isEmpty(sId) ? siteId : sId,
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetServiceCode(model);

      setSelectedCheckOption(null);
      if (response.data.code === 0) {
        setServiceData(response.data.data);
      } else {
        setServiceData([]);
      }
    } catch (e) {
      setServiceData([]);
    }
  };

  // 디바이스 카메라 조회
  const apiGetDeviceStatCamCall = async (devId) => {
    const model = {
      siteId: formData.siteId,
      devId: devId,
    };

    try {
      const response = await apiGetDeviceStatCam(model);

      if (response.data.code === 0 || response.data.code === 10) {
        if (isEmpty(response.data.data)) {
          Modal.info({
            title: "상태확인",
            icon: null,
            content: "조회된 결과가 없습니다.",
            okText: "확인",
            centered: true,
            onOk() {},
          });
        } else {
          setMediaData([...response.data.data]);
          setIsModalVisible(true);
        }
      }
    } catch (e) {}
  };

  useEffect(() => {
    apiGetSitesCompCall().then();

    if (!isEmpty(defaultValue.siteId)) {
      apiGetServiceCodeCall(defaultValue.siteId).then();
    }
  }, []);

  useEffect(() => {
    if (sitesData != null && sitesData.length > 0 && !initStatus.current.get(StatusOptions.SITE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SITE, true);

      let includeFlag = false;
      if (!isEmpty(defaultValue.siteId)) {
        sitesData.forEach((item) => {
          if (item.siteId === defaultValue.siteId) {
            includeFlag = true;
          }
        });
      }
      if (includeFlag) {
        setFormData({ ...formData, ["siteId"]: defaultValue.siteId });
      }
    }
  }, [sitesData]);

  useEffect(() => {
    if (serviceData != null && serviceData.length > 0 && !initStatus.current.get(StatusOptions.SERVICE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SERVICE, true);
      setSelectedCheckOption(defaultValue.svcCd);
    }
  }, [serviceData]);

  useEffect(() => {
    if (
      !initStatus.current.get(StatusOptions.SEARCH) &&
      !isEmpty(formData.siteId) &&
      sitesData != null &&
      sitesData.length > 0 &&
      selectedCheckOption != null &&
      selectedCheckOption.length > 0 &&
      serviceData != null &&
      serviceData.length > 0
    ) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SEARCH, true);
      apiGetDeviceStatCall(null, true).then();
    }
  }, [formData.siteId, selectedCheckOption]);

  function resetForm() {
    setFormData({ ...formData, ["searchKeyword"]: "" });
    apiGetDeviceStatCall(null, true).then();
  }

  const getStatusClass = (status) => {
    switch (status) {
      case "연결해제":
        return "status-error";
      default:
        return "status-normal";
    }
  };

  // 디바이스 목록 조회
  const apiGetDeviceStatCall = async (value, form) => {
    const model = {
      siteId: form ? formData.siteId : siteId,
      svcCdList: selectedCheckOption,
      searchKeyword: value,
      sort: "5",
    };

    const modelParam = {
      siteId: form ? formData.siteId : siteId,
      svcCd: selectedCheckOption,
    };

    try {
      const response = await apiGetDeviceStat(model);

      setGlobalSessionParam(modelParam);

      if (response.data.code === 0) {
        setDeviceData([...response.data.data]);
      } else {
        setDeviceData([]);
      }
    } catch (e) {
      setDeviceData([]);
    }
  };

  const serviceHandleChange = (value) => {
    setSelectedCheckOption(value);
  };

  const confirm = (value, record) => {
    Modal.confirm({
      title: "앱 관리",
      icon: null,
      content: "상태 변경에 최대 2분의 시간이 소요될 수 있으니 잠시 후 상태 변경 완료 여부를 확인해주세요.",
      okText: "확인",
      cancelButtonProps: { style: { display: "none" } },
    });

    if (record.statCd === "DST00010") {
      record.statCd = "off";
    } else if (record.statCd === "DST00020") {
      record.statCd = "on";
    }

    apiGetDevApp(record.devId, record.statCd).then((r) => r);
  };

  // [SVC-0105014011] 디바이스 앱 상태변경
  const apiGetDevApp = async (devId, status) => {
    const response = await apiGet(`Device/app/${devId}/${status}`);
    try {
      setAppStat(response.data.data);
    } catch (e) {}
  };

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>디바이스 상태 관리</h1>
      <div className={"rpc-head-space rpc-pc"}>
        <SearchArea
          leftExtra={
            <Space size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={formData.siteId}
                  onChange={changeSite}
                >
                  {sitesData.map((values, index) => (
                    <Option key={index} value={values.siteId}>
                      {values.siteNm}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className='condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  style={{ width: 230 }}
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                >
                  {serviceData.map((values, index) => (
                    <Option key={index} value={values.catCd}>
                      {values.catNm}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
          }
        />
        <SearchArea
          title='디바이스 상태 목록'
          depth='depth2'
          rightExtra={
            <Space>
              <Search
                placeholder='검색'
                id='searchKeyword'
                value={formData.searchKeyword}
                onChange={handleChange}
                onSearch={(keyword) => apiGetDeviceStatCall(keyword, true)}
              />
              <Button className='btn-gray' onClick={resetForm}>
                초기화
              </Button>
            </Space>
          }
        />
      </div>

      <div className={"rpc-head-space rpc-mobile"}>
        <SectionTitleArea title='디바이스 상태 목록' depth='depth2' />
        <SearchArea
          leftExtra={
            <Space className={"rpc-head-container"} size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={formData.siteId}
                  onChange={changeSite}
                >
                  {sitesData.map((values, index) => (
                    <Option key={index} value={values.siteId}>
                      {values.siteNm}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className='rpc-head-item condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  style={{ width: 230 }}
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                >
                  {serviceData.map((values, index) => (
                    <Option key={index} value={values.catCd}>
                      {values.catNm}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
          }
          rightExtra={
            <Space className={"rpc-head-container"}>
              <Search
                className={"rpc-head-item"}
                placeholder='검색'
                id='searchKeyword'
                value={formData.searchKeyword}
                onChange={handleChange}
                onSearch={(keyword) => apiGetDeviceStatCall(keyword, true)}
              />
              <Button className='btn-gray' style={{ width: "72px" }} onClick={resetForm}>
                초기화
              </Button>
            </Space>
          }
        />
      </div>

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table dataSource={deviceData} pagination={false} bordered showSorterTooltip={false} scroll={{ x: 900 }}>
          <Column title='No' dataIndex='no' key='1' width='50px' render={(value, record, index) => index + 1} />
          <Column
            title='서비스'
            dataIndex='catNm'
            key='2'
            sorter={(a, b) => String(a.catNm).localeCompare(String(b.catNm))}
          />
          <Column
            title='시리얼 No'
            dataIndex='serialNo'
            key='3'
            sorter={(a, b) => String(a.serialNo).localeCompare(String(b.serialNo))}
          />
          <Column
            title='디바이스 유형'
            dataIndex='devNm'
            key='4'
            sorter={(a, b) => String(a.devNm).localeCompare(String(b.devNm))}
          />
          <Column
            title='구역'
            dataIndex='znNm'
            key='5'
            sorter={(a, b) => String(a.znNm).localeCompare(String(b.znNm))}
          />
          <Column
            title='장비'
            dataIndex='equSn'
            key='5'
            sorter={(a, b) => String(a.equSn).localeCompare(String(b.equSn))}
          />
          <Column
            title='등록일'
            dataIndex='createDt'
            key='6'
            sorter={(a, b) => String(a.createDt).localeCompare(String(b.createDt))}
            render={(value) => <Moment date={value} format={"YYYY-MM-DD"} />}
          />
          <ColumnGroup title='디바이스 상태'>
            <Column
              title='통신'
              dataIndex='codeNm'
              key='7'
              sorter={(a, b) => String(a.codeNm).localeCompare(String(b.codeNm))}
              render={(status) => <span className={getStatusClass(status)}>{status}</span>}
            />
            <Column
              title={"앱 관리"}
              colSpan={2}
              dataIndex={"statCd"}
              render={(value, record, index) => (
                <Button type={"primary"} disabled={value !== "DST00020"} onClick={() => confirm(value, record)}>
                  on
                </Button>
              )}
            />
            <Column
              colSpan={0}
              dataIndex={"statCd"}
              render={(value, record, index) => (
                <Button type={"primary"} disabled={value === "DST00020"} onClick={() => confirm(value, record)}>
                  off
                </Button>
              )}
            />
            <Column
              title={"배터리 잔량"}
              dataIndex={"bat"}
              onCell={(record, index) => {
                return {
                  style: {
                    color: record.bat <= 20 ? "red" : "",
                  },
                };
              }}
              render={(value) => <div>{value}%</div>}
            />
            <Column
              title='CPU 온도'
              dataIndex='cpuTemp'
              key='8'
              sorter={(a, b) => String(a.cpuTemp).localeCompare(String(b.cpuTemp))}
              render={(value) => value + " ℃"}
            />
            <Column
              title='카메라'
              dataIndex='camera'
              key='9'
              render={(value, record) => (
                <Button
                  onClick={() => {
                    apiGetDeviceStatCamCall(record.devId).then();
                  }}
                >
                  상태확인
                </Button>
              )}
            />
            <Column
              title='최종 업데이트 일시'
              dataIndex='updateDt'
              key='10'
              sorter={(a, b) => String(a.updateDt).localeCompare(String(b.updateDt))}
              defaultSortOrder='descend'
              render={(value) => <Moment date={value} format={"YYYY-MM-DD HH:mm"} />}
            />
          </ColumnGroup>
        </Table>
      </div>

      <Modal
        title='상태확인'
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        getContainer={false}
        width={434}
        centered
        footer={null}
        bodyStyle={{ paddingBottom: "35px" }}
        // 스와이퍼가 있는 모달에서 마우스로 슬라이딩시 터치 미스로 딤처리 영역 클릭시 팝업이 닫혀버리는 현상 방지하기위해 지정 maskClosable
        maskClosable={false}
      >
        <PopDeviceStatus mediaData={mediaData} />
      </Modal>
    </Styles>
  );
}

export default ManageDevice;
